var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5C8.25 4.58579 8.58579 4.25 9 4.25H16C16.4142 4.25 16.75 4.58579 16.75 5C16.75 5.41421 16.4142 5.75 16 5.75H9C8.58579 5.75 8.25 5.41421 8.25 5Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.25C12.9142 4.25 13.25 4.58579 13.25 5V18C13.25 18.6858 13.8142 19.25 14.5 19.25H16C16.4142 19.25 16.75 19.5858 16.75 20C16.75 20.4142 16.4142 20.75 16 20.75H14.5C12.9858 20.75 11.75 19.5142 11.75 18V5C11.75 4.58579 12.0858 4.25 12.5 4.25Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 12.5C11.75 12.0858 12.0858 11.75 12.5 11.75H16C16.4142 11.75 16.75 12.0858 16.75 12.5C16.75 12.9142 16.4142 13.25 16 13.25H12.5C12.0858 13.25 11.75 12.9142 11.75 12.5Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.75C3.31421 2.75 2.75 3.31421 2.75 4V6C2.75 6.68579 3.31421 7.25 4 7.25H7C7.68579 7.25 8.25 6.68579 8.25 6V4C8.25 3.31421 7.68579 2.75 7 2.75H4ZM1.25 4C1.25 2.48579 2.48579 1.25 4 1.25H7C8.51421 1.25 9.75 2.48579 9.75 4V6C9.75 7.51421 8.51421 8.75 7 8.75H4C2.48579 8.75 1.25 7.51421 1.25 6V4Z",
    fill: "#151819"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.75C3.31421 2.75 2.75 3.31421 2.75 4V6C2.75 6.68579 3.31421 7.25 4 7.25H7C7.68579 7.25 8.25 6.68579 8.25 6V4C8.25 3.31421 7.68579 2.75 7 2.75H4ZM1.25 4C1.25 2.48579 2.48579 1.25 4 1.25H7C8.51421 1.25 9.75 2.48579 9.75 4V6C9.75 7.51421 8.51421 8.75 7 8.75H4C2.48579 8.75 1.25 7.51421 1.25 6V4Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 3.75C16.9542 3.75 16.75 3.95421 16.75 4.20001V5.79999C16.75 6.04579 16.9542 6.25 17.2 6.25H20.8C21.0458 6.25 21.25 6.04579 21.25 5.79999V4.20001C21.25 3.95421 21.0458 3.75 20.8 3.75H17.2ZM15.25 4.20001C15.25 3.12581 16.1258 2.25 17.2 2.25H20.8C21.8742 2.25 22.75 3.12581 22.75 4.20001V5.79999C22.75 6.87419 21.8742 7.75 20.8 7.75H17.2C16.1258 7.75 15.25 6.87419 15.25 5.79999V4.20001Z",
    fill: "#151819"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 3.75C16.9542 3.75 16.75 3.95421 16.75 4.20001V5.79999C16.75 6.04579 16.9542 6.25 17.2 6.25H20.8C21.0458 6.25 21.25 6.04579 21.25 5.79999V4.20001C21.25 3.95421 21.0458 3.75 20.8 3.75H17.2ZM15.25 4.20001C15.25 3.12581 16.1258 2.25 17.2 2.25H20.8C21.8742 2.25 22.75 3.12581 22.75 4.20001V5.79999C22.75 6.87419 21.8742 7.75 20.8 7.75H17.2C16.1258 7.75 15.25 6.87419 15.25 5.79999V4.20001Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 11.25C16.9542 11.25 16.75 11.4542 16.75 11.7V13.3C16.75 13.5458 16.9542 13.75 17.2 13.75H20.8C21.0458 13.75 21.25 13.5458 21.25 13.3V11.7C21.25 11.4542 21.0458 11.25 20.8 11.25H17.2ZM15.25 11.7C15.25 10.6258 16.1258 9.75 17.2 9.75H20.8C21.8742 9.75 22.75 10.6258 22.75 11.7V13.3C22.75 14.3742 21.8742 15.25 20.8 15.25H17.2C16.1258 15.25 15.25 14.3742 15.25 13.3V11.7Z",
    fill: "#151819"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 11.25C16.9542 11.25 16.75 11.4542 16.75 11.7V13.3C16.75 13.5458 16.9542 13.75 17.2 13.75H20.8C21.0458 13.75 21.25 13.5458 21.25 13.3V11.7C21.25 11.4542 21.0458 11.25 20.8 11.25H17.2ZM15.25 11.7C15.25 10.6258 16.1258 9.75 17.2 9.75H20.8C21.8742 9.75 22.75 10.6258 22.75 11.7V13.3C22.75 14.3742 21.8742 15.25 20.8 15.25H17.2C16.1258 15.25 15.25 14.3742 15.25 13.3V11.7Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 18.75C16.9542 18.75 16.75 18.9542 16.75 19.2V20.8C16.75 21.0458 16.9542 21.25 17.2 21.25H20.8C21.0458 21.25 21.25 21.0458 21.25 20.8V19.2C21.25 18.9542 21.0458 18.75 20.8 18.75H17.2ZM15.25 19.2C15.25 18.1258 16.1258 17.25 17.2 17.25H20.8C21.8742 17.25 22.75 18.1258 22.75 19.2V20.8C22.75 21.8742 21.8742 22.75 20.8 22.75H17.2C16.1258 22.75 15.25 21.8742 15.25 20.8V19.2Z",
    fill: "#151819"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2 18.75C16.9542 18.75 16.75 18.9542 16.75 19.2V20.8C16.75 21.0458 16.9542 21.25 17.2 21.25H20.8C21.0458 21.25 21.25 21.0458 21.25 20.8V19.2C21.25 18.9542 21.0458 18.75 20.8 18.75H17.2ZM15.25 19.2C15.25 18.1258 16.1258 17.25 17.2 17.25H20.8C21.8742 17.25 22.75 18.1258 22.75 19.2V20.8C22.75 21.8742 21.8742 22.75 20.8 22.75H17.2C16.1258 22.75 15.25 21.8742 15.25 20.8V19.2Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDepartment);
export default __webpack_public_path__ + "static/media/side_department.b19576b8e90f110f00ea2c94f21658b4.svg";
export { ForwardRef as ReactComponent };